import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCzB2ZyHzWwNj1_G4X14oubgnpJJg0m8cE",
  authDomain: "tradesimple-2a89f.firebaseapp.com",
  databaseURL: "https://tradesimple-2a89f-default-rtdb.firebaseio.com",
  projectId: "tradesimple-2a89f",
  storageBucket: "tradesimple-2a89f.firebasestorage.app",
  messagingSenderId: "451771739027",
  appId: "1:451771739027:web:05faaaf7ebfe0de3a15666",
  measurementId: "G-8G44D3PH5Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database
export const db = getDatabase(app);

export default app;
